function PageContent({ title, children }) {
    return (
        <div className="center-align">
            <h1>{title}</h1>
            {children}
        </div>
    );
}

export default PageContent;